import React, { useState } from 'react';

import { Box } from '@mui/material';

import ContainerLoadingIndicator from 'src/components/common/loading/ContainerLoadingIndicator';
import PageWithLayout from 'src/components/layout/PageWithLayout';
import { CreateEditSiteModal } from 'src/features/site/components/CreateEditSiteModal';
import PagedSitesContainer from 'src/features/site/components/PagedSitesContainer';
import { SITE_LOADING_KEY } from 'src/features/site/store';

export const DashboardPage: React.FC = () => {
	const [shouldRefreshSites, setShouldRefreshSites] = useState({
		refreshSites: false,
	});
	const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

	return (
		<PageWithLayout breadcrumbs={[]}>
			<Box sx={{ p: 0.5 }}>
				<Box sx={{ position: 'relative' }}>
					<ContainerLoadingIndicator loadingKey={SITE_LOADING_KEY} />
					<PagedSitesContainer
						refreshSites={shouldRefreshSites}
						onCreateSiteClick={() => setIsCreateModalOpen(true)}
					/>
				</Box>

				<CreateEditSiteModal
					open={isCreateModalOpen}
					onClose={() => setIsCreateModalOpen(false)}
					onSubmit={() => {
						setIsCreateModalOpen(false);
						setShouldRefreshSites({ refreshSites: true });
					}}
				/>
			</Box>
		</PageWithLayout>
	);
};
